import { c as _c } from "react/compiler-runtime";
import { getValuesForSelectedOptions } from 'commons/productUtils';
import avo from 'analytics/avo';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';
import useProductFavoriteV2 from '../useProductFavoriteV2';
const getEventData = ({
  product,
  price,
  optionPrice,
  options,
  selectedOptions,
  upSellProduct,
  upSellProductOptionPrice,
  isFavorited = false,
  isDecideLater = false
}) => {
  const {
    fabric
  } = getValuesForSelectedOptions(options, selectedOptions);
  return {
    fabric_id: fabric?.id || 0,
    fabric_name: isDecideLater ? 'Decide Later' : fabric?.value || '',
    fabric_color: fabric?.color || '',
    favorited: isFavorited,
    product_id: product.id,
    product_name: product.name,
    price: price.final_price + optionPrice,
    full_price: price.original_price + optionPrice,
    product_family: product.family?.name,
    product_type: product.type.name,
    upsell_product_id: upSellProduct.id,
    upsell_product_name: upSellProduct.name,
    upsell_product_price: (upSellProduct.meta?.price?.final_price || 0) + (upSellProductOptionPrice || 0),
    upsell_product_full_price: (upSellProduct.meta?.price?.original_price || 0) + (upSellProductOptionPrice || 0)
  };
};
const usePDPAddUpSellProductEvent = () => {
  const $ = _c(8);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    data: optionData
  } = usePDPOptions();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let t0;
  if ($[0] !== basicDetails || $[1] !== isFavorited || $[2] !== optionData.options || $[3] !== optionData.selectedOptions || $[4] !== pdpSelectedCustomizerTab || $[5] !== priceData?.optionPrice || $[6] !== priceData?.price) {
    t0 = (upSellProduct, optionPrice) => {
      const eventData = getEventData({
        isFavorited,
        product: basicDetails,
        price: priceData?.price,
        optionPrice: priceData?.optionPrice,
        options: optionData.options,
        selectedOptions: optionData.selectedOptions,
        upSellProduct,
        upSellProductOptionPrice: optionPrice,
        isDecideLater: pdpSelectedCustomizerTab === "decide-later"
      });
      avo.upsellProductAdded({
        fabricColor: eventData.fabric_color,
        fabricId: eventData.fabric_id,
        fabricName: eventData.fabric_name,
        favorited: upSellProduct.meta?.customer?.favorited,
        fullPrice: parseFloat(eventData.upsell_product_full_price),
        price: parseFloat(eventData.upsell_product_price),
        productFamily: upSellProduct?.family?.name || "",
        productId: upSellProduct.id,
        name: upSellProduct.name,
        category: upSellProduct.type?.name,
        currency: "USD"
      });
    };
    $[0] = basicDetails;
    $[1] = isFavorited;
    $[2] = optionData.options;
    $[3] = optionData.selectedOptions;
    $[4] = pdpSelectedCustomizerTab;
    $[5] = priceData?.optionPrice;
    $[6] = priceData?.price;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const addUpSellProductEvent = t0;
  return addUpSellProductEvent;
};
export default usePDPAddUpSellProductEvent;